import * as Sentry from "@sentry/react";
import { BUILD_TIME } from './version';

export const initSentry = () => {
  // Only initialize in production
  if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      enabled: import.meta.env.PROD,
      release: BUILD_TIME,
      sendDefaultPii: true,
    });
  }
};
